import gql from "graphql-tag";

export const CLIENT_DISPLAY_QUERY = gql`
    query clientDisplayQuery($vClientShortName: String!) {
        clientDisplayData: getClientInfoForDisplay(
            vClientShortName: $vClientShortName
        ) {
            clientId
            clientName
            isIndividualClient
            titleText
            subtitleText
            additionalInfoMd
            colorScheme
            s3Filename
        }
    }
`;

export interface ClientDisplayData {
    clientDisplayData: {
        clientId: number;
        clientName: string;
        isIndividualClient: boolean;
        titleText: string;
        subtitleText: string;
        additionalInfoMd: string;
        colorScheme: any;
        s3Filename: string;
    };
}
